import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SB_PUBLISHABLE_KEY,
  {
    auth: {
      flowType: "implicit",
      detectSessionInUrl: false,
    },
  },
);
